import React from 'react';
import { motion } from 'framer-motion';
import { Github, Linkedin, Twitter, Mail } from 'lucide-react';
import { socialMedia } from '../data/data';
import { trackEvent } from '../lib/firebase';
import { staggerContainer, fadeInUp } from '../lib/motion';

const iconMap = {
  Github: Github,
  Linkedin: Linkedin,
  Twitter: Twitter,
  Mail: Mail
};

const Contact = () => {
  return (
    <section id="contact" className="py-24 bg-[#f8f8f6]">
      <div className="container-editorial">
        <div className="grid grid-cols-12 gap-y-8 lg:gap-x-8">
          <div className="col-span-12 lg:col-span-6">
            <motion.div
              variants={staggerContainer}
              initial="initial"
              whileInView="animate"
              viewport={{ once: true, margin: "-100px" }}
            >
              <motion.p
                variants={fadeInUp}
                className="text-xs uppercase tracking-widest text-[#666666] mb-4"
                style={{ fontFamily: 'var(--font-sans)' }}
              >
                Contact
              </motion.p>
              <motion.h2
                variants={fadeInUp}
                className="text-5xl font-normal text-[#1a1a1a] mb-8"
                style={{ fontFamily: 'var(--font-serif)' }}
              >
                Let's Connect
              </motion.h2>

              <motion.p
                variants={fadeInUp}
                className="text-lg text-[#666666] mb-12 leading-relaxed max-w-lg"
                style={{ fontFamily: 'var(--font-sans)', fontWeight: 300 }}
              >
                Available for select projects and consulting opportunities.
              </motion.p>

              <motion.div
                className="flex flex-col gap-4 mb-16"
                variants={staggerContainer}
              >
                {socialMedia.map((social) => {
                  const Icon = iconMap[social.icon];
                  return (
                    <motion.a
                      key={social.name}
                      href={social.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="group inline-flex items-center gap-3 text-[#666666] hover:text-[#1a1a1a] transition-colors duration-300 w-fit"
                      variants={fadeInUp}
                      whileHover={{ x: 4, transition: { duration: 0.2 } }}
                      onClick={() => {
                        trackEvent('social_media_clicked', {
                          social_id: social.name,
                        })
                      }}
                    >
                      <Icon className="w-4 h-4" />
                      <span className="text-sm uppercase tracking-wide relative" style={{ fontFamily: 'var(--font-sans)' }}>
                        {social.name}
                        <motion.span
                          className="absolute -bottom-1 left-0 h-[1px] bg-[#8B4513]"
                          initial={{ width: 0 }}
                          whileHover={{ width: '100%' }}
                          transition={{ duration: 0.3 }}
                        />
                      </span>
                    </motion.a>
                  );
                })}
              </motion.div>

              {/* <motion.div
                variants={fadeInUp}
                className="border-t border-[#d4d4d0] pt-8"
              >
                <p className="text-xs text-[#666666] uppercase tracking-wider" style={{ fontFamily: 'var(--font-sans)' }}>
                  © {new Date().getFullYear()} {"Jonty"}.
                </p>
              </motion.div> */}
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;